import { Component, OnInit, AfterViewChecked, AfterViewInit, ViewChild, computed, signal, model, inject, effect, WritableSignal } from '@angular/core';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';

import { IBook, BookList, IBookSortFilterSet, BookSortFilterSet, ISeriesEntry, Book } from '../../_models';
import { BookService } from '../../services/book.service';
import { AuthService } from '../../services/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { HasReadChipsComponent } from '../chips/has-read-chips/has-read-chips.component';
import { IsInterestedChipsComponent } from '../chips/is-interested-chips/is-interested-chips.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { JsonPipe, NgIf } from '@angular/common';
import { FilterSortService } from 'src/app/services/filter-sort.service';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { LoadingService } from 'src/app/services';
import { Router } from '@angular/router';
import { DataSource } from '@angular/cdk/collections';

export type RowType = {
  id: string,
  title: string,
  series: string[],
  type: string,
  addedByMe: boolean,
  imInterested: boolean,
  iHaveRead: boolean
}
@Component({
  selector: 'kbm-books-list',
  templateUrl: './books-list.component.html',
  styleUrls: [
    './books-list.component.scss'
  ],
  standalone: true,
  imports: [
    MatTableModule,
    MatSortModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatCheckboxModule,
    MatPaginatorModule,
    JsonPipe,
  ]
})


export class BooksListComponent {

  books = model<IBook[]>([]);
  bookDisplay = new MatTableDataSource<{
    id: string,
    type: string,
    title: string,
    series: ISeriesEntry,
    addedByMe: boolean,
    imInterested: boolean,
    iHaveRead: boolean,
  }>([])


  authService = inject(AuthService);
  bookService = inject(BookService);
  loadingService = inject(LoadingService);
  router = inject(Router);

  isAuthenticated = computed(() => this.authService.isLoggedIn());
  me = computed(() => this.authService.user()?.username);

  retVal: string = '-';

  displayedColumns = [
    'type',
    'title',
    'series',
    'addedByMe',
    'imInterested',
    'iHaveRead',
  ];


  constructor() {
    effect(() => {
      const books = this.books();
      this.bookDisplay.data = books.map((b: IBook) => {
        return {
          id: b.amazon_id,
          title: b.title,
          series: b.series![0],
          type: b.type,
          addedByMe: (b.addedBy == this.me()) ? true : false,
          imInterested: (b.isInterested && b.isInterested.includes(this.me()!)) ? true : false,
          iHaveRead: b.hasRead?.includes(this.me()!) ? true : false,
        };
      });
    });
  }


  onTitleClick(book: any, event: any): void {
    console.log('onTitleClick', book, event);

    sessionStorage.setItem('currentBook', book.id);
    this.router.navigate([
      '/books/',
      book.id,
      {}
    ]);

  }

  onAddedByMeChange($event: MatCheckboxChange, row: any) {
    const asin = row.id;
    const book = signal<Book>(this.books().find((b) => b.amazon_id === asin)!);
    this.bookService.setAddedByMe(book, $event.checked);
    console.log('onAddedByMeChange', book());
  }

  onCheckBoxChange(field: string, $event: any, row: RowType) {
    const asin = row.id;
    const book = signal<Book>(this.books().find((b) => b.amazon_id === asin)!);

    if (field === 'iHaveRead') {
      this.bookService.setHasRead(book, $event.checked);
    } else if (field === 'imInterested') {
      this.bookService.setIsInterested(book, $event.checked);
    }
  }

  getSeriesDisplay(series: ISeriesEntry | null): string {
    if (series != null) {
      return series.name + ' - ' + series.readingOrder;
    } else {
      return '.';
    }
  }

}